var map = {
	"./beijing.png": "/Iit",
	"./boston.png": "04Ey",
	"./foshan.png": "Pm8d",
	"./london.png": "/a/r",
	"./macau.png": "VwS3",
	"./nanchang.png": "chfF",
	"./shenzhen.png": "uJXN",
	"./slincon.png": "exo4",
	"./vienna.png": "85o8",
	"./xian.png": "U9wz",
	"./zhuhai.png": "vTJ+"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "qxDD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/office nonrecursive \.png$
// module id = qxDD
// module chunks = 1